(function() {
    'use strict';

    angular.module('app.controllers')

        .controller('NavCtrl', NavCtrl);

    /* @ngInject */
    function NavCtrl($state, App, AuthFactory) {

        var navvm = this;
        navvm.App = App;
        navvm.tabClass = tabClass;
        navvm.pageClass = pageClass;
        navvm.toggleSidebar = toggleSidebar;
        navvm.logout = logout;
        navvm.pages = pages;

        function tabClass(module) {
            if (module == App.module) return 'active open selected';
            return null;
        }

        function pageClass(page) {
            if (page == App.page) {
                return 'active';
            }
            return null;
        }

        function toggleSidebar() {
            App.toggleSidebar();
        }

        function logout() {
            App.logout().then(function() {
                // delete existing token from local storage
                AuthFactory.logout();
            });
        }

        // Get the pages for the current module
        function pages() {
            for (var i = 0; i < App.modules.length; i++) {
                var module = App.modules[i];
                if (module.module === App.module) {
                    return module.pages;
                }
            }
        }
    }

})();